// TVFrame — big-screen panel for projectType='tv'.
// Wide panel silhouette with stand, deep-blue accent.
// Thumbnail insets in the screen area.

export const TVFrame = {
  flow: 'column',
  width: '100%',
  height: '100%',
  position: 'relative',
  round: 'inherit',
  overflow: 'hidden',
  alignItems: 'center',
  justifyContent: 'center',

  // TV outer housing
  TVPanel: {
    position: 'relative',
    width: '100%',
    height: '100%',
    flow: 'column',

    // Screen bezel
    Bezel: {
      flexGrow: '1',
      position: 'relative',
      round: 'W',
      border: '1px solid',
      borderColor: 'electricBlue.45',
      background: 'black.5',
      overflow: 'hidden',

      // Screen content — thumbnail insets here
      Screen: {
        position: 'absolute',
        inset: '0',
        overflow: 'hidden',
        background: 'electricBlue.06',

        EmptyState: {
          if: (el, s) => !s.screenshot && !s.screenshotDev && !s.icon,
          position: 'absolute',
          inset: '0',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 'Y',
          pointerEvents: 'none',

          Glyph: {
            fontSize: 'B2',
            color: 'electricBlue.3',
            text: '▬'
          },
          Hint: {
            tag: 'span',
            text: 'TV app',
            fontSize: 'Z1',
            color: 'white.22',
            fontStyle: 'italic'
          }
        }
      },

      // Power indicator LED
      PowerDot: {
        position: 'absolute',
        bottom: 'V',
        right: 'W',
        width: 'V',
        height: 'V',
        round: '50%',
        background: 'electricBlue.85',
        zIndex: '2',
        pointerEvents: 'none'
      }
    },

    // Stand neck
    Stand: {
      flexShrink: '0',
      alignSelf: 'center',
      width: 'B',
      height: 'W',
      background: 'electricBlue.3',
      borderBottomLeftRadius: 'V',
      borderBottomRightRadius: 'V'
    },

    // Stand base
    StandBase: {
      flexShrink: '0',
      alignSelf: 'center',
      width: 'C',
      height: 'V',
      round: 'Z',
      background: 'electricBlue.2'
    }
  },

  // Deep-blue accent border
  AccentBorder: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: 'V',
    height: '100%',
    background: 'electricBlue',
    opacity: '0.6',
    pointerEvents: 'none'
  }
}
